const optionsLabel = (label) => {
  return label || 'Missing options label in app.js';
}
export default optionsLabel;
